module.exports = __webpack_public_path__ + "static/img/21.7e394c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/21.png
// module id = K+ke
// module chunks = 5